import { MarketEnum } from '@model/enum/market.enum';
import { ConfigService } from '@services/webFeeder/config.service';
import { SidebarService } from '@services/sidebar.service';
import { Constants } from '@utils/constants';
import { SideEnum } from '@model/enum/side.enum';
import { NotificationsService } from 'angular2-notifications';
import { Component, Output, EventEmitter, Input } from '@angular/core';
import { AuthServer } from '@services/auth-server.service';
import { NormalModalComponent } from '@component/normal-modal/normal-modal.component';
import { EletronicSignatureModalComponent } from '@component/eletronic-signature-modal/eletronic-signature-modal.component';
import { MatDialog } from '@angular/material/dialog';
import { DailyOrderService } from '@services/webFeeder/sckt-daily-order.service';
import { TypeOrderRequestEnum } from '@model/enum/type-order-send.enum';

@Component({
  selector: 'app-billet-actions',
  templateUrl: './billet-actions.component.html'
})
export class BilletActionsComponent {
  @Output() actionConfirm: EventEmitter<{ side: SideEnum, qtd?: number }> = new EventEmitter();

  @Input() statusOmsOnline = false;
  @Input() isLoggedNegotiation = false;
  @Input() termOperator = false;
  @Input() positionNetDay = '';
  @Input() dense: boolean;
  @Input() asset = '';
  @Input() market: any;
  @Input() isBilletChart: boolean;
  @Input() filters = { quote: 'Todos', buyOrSell: 'Todos', state: 'Todos' };
  @Output() openConfirmationBillit = new EventEmitter<any>();
  private msgOffline = Constants.MSG_OFFLINE_NEGOTIATION_02;
  private msgStatusOmsOffile = Constants.MSG_STATUS_OFFLINE_OMS;
  private msgQuoteInvalid = Constants.WORKSPACE_MSG005;
  private eletronicSignature = this._configService.getEletronicSignatureType();
  SideEnum = SideEnum;
  signature = this._configService.getHbSignature();

  constructor(
    private _notificationService: NotificationsService,
    private _sidebarService: SidebarService,
    private _configService: ConfigService,
    private _authServer: AuthServer,
    private _dialog: MatDialog,
    private _dailyOrderService: DailyOrderService,
  ) { }

  sendOrder(side: SideEnum, isMarket?: boolean) {
    if (!this.validLoggedNegotiation()) {
      return;
    }
    if (!this.statusOmsOnline) {
      this._notificationService.alert('', this.msgStatusOmsOffile);
      return;
    }
    const value = {
      isMarket: isMarket ? true : false,
      side: side
    };
    this.openConfirmationBillit.emit(value);
  }

  clearOrder() {
    if (!this.validLoggedNegotiation()) {
      return;
    }
    if (!this.termOperator) {
      const posTemp = this.positionNetDay ? Number(this.positionNetDay) : 0;
      let loteSizeOrder = 0;
      if (posTemp < 0) {
        loteSizeOrder = posTemp * -1;
        this.actionConfirm.emit({ side: SideEnum.BUY, qtd: loteSizeOrder });
      } else if (posTemp > 0) {
        loteSizeOrder = posTemp;
        this.actionConfirm.emit({ side: SideEnum.SELL, qtd: loteSizeOrder });
      } else {
        this._notificationService.warn('', Constants.ORDER_CLEAR_MSG013.replace('[QUOTE]', this.asset.toUpperCase()));
        return;
      }
    }
  }

  clearPosition() {
    if (!this.validLoggedNegotiation()) {
      return;
    }
    const posTemp = this.positionNetDay ? Number(this.positionNetDay) : 0;
    if (posTemp === 0) {
      this._notificationService.warn('', Constants.ORDER_CLEAR_MSG013.replace('[QUOTE]', this.asset.toUpperCase()));
      return;
    }
    let modalOrders;
    const signature = this._configService.getHbSignature();
    if (this.eletronicSignature && this.eletronicSignature.isActive && !this._configService.isUserAssessorLogged()) {
      if (signature) {
        this.validSignaure(signature, 'clearPosition');
      } else {
        modalOrders = this._dialog.open(EletronicSignatureModalComponent, {
          panelClass: Constants.ELETRONIC_SIGNATURE_MODAL,
          width: '350px',
          disableClose: true
        });
      }
    } else {
      modalOrders = this._dialog.open(NormalModalComponent, {
        data: { title: Constants.ORDER_HISTORY_MSG011, body: Constants.ORDER_HISTORY_MSG012, isHistoryOrderWSO2: false },
        panelClass: 'mat-modal-normal',
      });
    }
    if (modalOrders) {
      modalOrders.afterClosed().subscribe(result => {
        if (result) {
          this.sendClearPosition(this.asset, this.market);
        } else {
          if (this._configService.isLoginTypeWSO2() && !this._configService.isUserAssessorLogged()) {
            this.callAlert('', Constants.BILLET_ORDER_SEND_06, Constants.ALERT_TYPE.info);
          }
        }
      });
    }
  }

  sendClearPosition(symbol: string, market: MarketEnum) {
    this._authServer.iNegotiation.customLiquidationClient(symbol, market)
      .subscribe(res => {
        if (res && res.code === 0) {
          this.callAlert('', Constants.BILLET_ORDER_SEND_14, Constants.ALERT_TYPE.info);
        } else {
          this.callAlert('', res.message ? res.message : Constants.BILLET_ORDER_SEND_09, Constants.ALERT_TYPE.error);
        }
      }, () => {
        this.callAlert('', Constants.BILLET_ORDER_SEND_09, Constants.ALERT_TYPE.error);
      });
  }

  validLoggedNegotiation() {
    if (!this.asset) {
      this._notificationService.warn('', this.msgQuoteInvalid);
      return false;
    } else if (!this.isLoggedNegotiation) {
      this._notificationService.warn('', this.msgOffline);
      this._sidebarService._clickOpenTabLoginBroker.next(true);
      return false;
    }
    return true;
  }

  cancelAllOrder() {
    if (!this.validLoggedNegotiation()) {
      return;
    }
    const modalOrders = this._dialog.open(NormalModalComponent, {
      data: { title: Constants.ORDER_HISTORY_MSG007, body: Constants.ORDER_HISTORY_MSG008, isHistoryOrderWSO2: false },
      panelClass: 'mat-modal-normal',
    });
    if (modalOrders) {
      modalOrders.afterClosed().subscribe(result => {
        if (result) {
          this._dailyOrderService.verifyEletronicSignature(TypeOrderRequestEnum.CANCEL_ALL_ORDER, this.asset, true, null, null);
        }
      });
    }
  }

  validSignaure(signature, action) {
    let paramsSignature;
    let clientId;
    if (this.eletronicSignature.type === Constants.ELETRONIC_SIGNATURE_TYPES.string) {
      clientId = Number(this._configService.getHbAccountId());
      paramsSignature = { user_client_id: clientId, signature: signature };
    } else {
      paramsSignature = signature;
    }
    this._authServer.iEletronicSignature.validateSignature(paramsSignature)
      .subscribe(res => {
        if ((this.eletronicSignature.type === Constants.ELETRONIC_SIGNATURE_TYPES.string && res && res._isScalar !== false && res.is_valid)
          || (this.eletronicSignature.type === Constants.ELETRONIC_SIGNATURE_TYPES.virtual_keyboard
            && res && res.IsResponseOk && res.SerializedObject && JSON.parse(res.SerializedObject).Autenticado)) {
          if (action === 'clearPosition') {
            this.sendClearPosition(this.asset, this.market);
          }
        } else {
          this.callAlert('', Constants.BILLET_ORDER_SEND_07, Constants.ALERT_TYPE.error);
          this._configService.deleteHbSignature();
          return false;
        }
      });
  }

  callAlert(title, message, typeAlert) {
    this._configService.systemNotificationMessage(title, message, typeAlert);
  }

}
